import React, { useMemo, useState } from "react";
import { LargeButton, OverlayLoader, Ptag } from "components/core";
import { useNavigate, useParams } from "react-router";
import useFetchGrade from "./useFetchGrade";
import GradeStrip from "./GradeStrip";
import GradeView from "./GradeView";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";
import {
  getProductFromUserplan,
  planSetupInProgress,
  planSetupPendingInProgress,
  roleIsAdmin,
} from "utlis/utils";
import { FLEX_PRODUCTS } from "constants";
import http from "services/httpService";
import routes from "components/routes";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function PlanOverview() {
  const navigate = useNavigate();
  const { userplan_id } = useParams();
  const [activeGrade, setActiveGrade] = useState(0);
  const { loading, isFlat, grades } = useFetchGrade(userplan_id);

  const crumbs = useMemo(() => {
    const product = getProductFromUserplan(userplan_id);
    const productName = FLEX_PRODUCTS[product?.name] || "";

    return [
      {
        name: "Dashboard",
        path: "/v1",
      },
      {
        name: productName,
      },
      {
        name: "Plan Setup",
        active: true,
      },
    ];
  }, [userplan_id]);

  const getGradeSelected = async () => {
    try {
      const { data } = await http.get("business/userplans_data_selected/");
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
      const gradesData = data.userplans_data[userplan_id].userplan_grades_data;
      if (gradesData.length > 0) {
        return gradesData[0];
      }
    } catch (e) {
      console.log(e);
    }
  };

  const editGrade = async () => {
    const gradeData = await getGradeSelected();
    if (!gradeData) return;

    localStorage.setItem("eb_current_plan", gradeData?.userplan);
    navigate(`/v1/grade-edit`, {
      state: {
        mappingId: gradeData?.plan_grade_mapping_id,
        postIssuance: true,
      },
    });
  };
  if (loading) return <OverlayLoader />;

  const showPlanSummarySubmitBtn = () => {
    if (planSetupInProgress() || planSetupPendingInProgress()) {
      return (
        <Box sx={{ marginTop: "30px" }}>
          <LargeButton onClick={handlePlanSummarySubmit} label={"Submit"} />
        </Box>
      );
    }
    return null;
  };

  const handlePlanSummarySubmit = () => {
    const grade_summary_details = JSON.parse(
      localStorage.getItem("eb_selected_values")
    );
    const eb_current_plan = localStorage.getItem("eb_current_plan");
    const productType =
      grade_summary_details?.userplans_data[eb_current_plan]?.product_type
        .product_type_name;
    if (
      ["health_insurance", "health_insurance_additional"].includes(productType)
    ) {
      navigate(`/${routes.PRE_CORPORATE_BUFFER}`);
    } else if (["top_up_health", "parental_cover"].includes(productType)) {
      navigate(`/${routes.UNIVERSAL_TPA}`);
    } else {
      navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`);
    }
  };

  const displayEditGradeBtn = (grades) => {
    if (grades.length < 2 && roleIsAdmin()) {
      return (
        <IconButton onClick={editGrade}>
          <EditIcon />
        </IconButton>
      );
    }
    return null;
  };
  
  const showBreakCrumbs = () => {
    if (planSetupInProgress() || planSetupPendingInProgress()) {
      return null;
    }
    return <BaseBreadcrumbs breadcrumbs={crumbs} />;
  };

  return (
    <div>
      {showBreakCrumbs()}
      {/* <NewGradeView /> */}
      <Ptag fontFamily="Instrument Serif" fontWeight="400" fontSize="36px" marginBottom="17px" lineHeight="32px">
        {isFlat ? "Plan Summary" : "Grade Setup Summary"}{" "}
        {displayEditGradeBtn(grades)}
      </Ptag>
      {!isFlat && (
        <GradeStrip
          activeGrade={activeGrade}
          setActiveGrade={setActiveGrade}
          grades={grades}
          editGrade={editGrade}
        />
      )}
      <div>
        {grades.map((grade, index) => (
          <div role="tabpanel" hidden={activeGrade !== index}>
            {activeGrade === index && <GradeView grade={grade} />}
          </div>
        ))}
      </div>
      {showPlanSummarySubmitBtn()}
    </div>
  );
}

export default PlanOverview;
